import Vue from 'vue';

export default class StatementDetailsMixin extends Vue {
  getCurrencyClass(value: number): { [key: string]: boolean } {
    return {
      'currency--positive': value > 0,
      'currency--empty': value === 0,
      'currency--negative': value < 0,
    };
  }

  getFormattedName(name: string): string {
    const splitName = name.toLowerCase().split(' ');
    const firstName = splitName[0];
    const lastName = splitName.slice(1, splitName.length).join(' ');
    return `${lastName}, ${firstName}`;
  }
}
